import { useParams } from 'react-router-dom';

import { OrganizationInvitationsPage } from '~/components/pages/OrganizationInvitationsPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const OrganizationInvitationsRoute: React.FC = () => {
  const { organizationId } = useParams();

  if (!organizationId) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardTemplate organizationId={organizationId}>
      <OrganizationInvitationsPage organizationId={organizationId} />
    </DashboardTemplate>
  );
};
